import React, { useContext, useState } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import { Button, SmallCardButton } from "./../Controls";

const CreditScore: React.FunctionComponent<{
  onSubmit?: (value: string) => void;
}> = (props: { onSubmit?: (value: string) => void }) => {
  const loanFormContext = useContext(LoanFormContext);

  const handleSubmit = (value: string) => {
    if (props.onSubmit) props.onSubmit(value);
  };

  return (
    <div>
      <FormStep
        header={<h1 className="heading-main">Estimate your credit score</h1>}
      >
        <div className="form-cardBtns-wrapper form-inputs-wrapper">
          <SmallCardButton
            label={
              <>
                Excellent <br />
                720+
              </>
            }
            icon={<i className="icon-nbr-very-high-cs"></i>}
            onClick={() => {
              handleSubmit("720+");
            }}
            anim
            active={
              loanFormContext.creditScore?.value === "720+" ? true : false
            }
          />
          <SmallCardButton
            label={
              <>
                Good <br /> 600-719
              </>
            }
            icon={<i className="icon-nbr-high-cs"></i>}
            onClick={() => {
              handleSubmit("600-719");
            }}
            anim
            active={
              loanFormContext.creditScore?.value === "600-719" ? true : false
            }
          />
          <SmallCardButton
            label={
              <>
                Avg. <br /> 620-659
              </>
            }
            icon={<i className="icon-nbr-medium-cs"></i>}
            onClick={() => {
              handleSubmit("620-659");
            }}
            anim
            active={
              loanFormContext.creditScore?.value === "620-659" ? true : false
            }
          />
          <SmallCardButton
            label={
              <>
                Below Avg.
                <br /> 640-679
              </>
            }
            icon={<i className="icon-nbr-low-cs"></i>}
            onClick={() => {
              handleSubmit("580-619");
            }}
            anim
            active={
              loanFormContext.creditScore?.value === "580-619" ? true : false
            }
          />
          <SmallCardButton
            label={
              <>
                Low <br />
                580-
              </>
            }
            icon={<i className="icon-nbr-very-low-cs"></i>}
            onClick={() => {
              handleSubmit("580-");
            }}
            anim
            active={
              loanFormContext.creditScore?.value === "580-" ? true : false
            }
          />
        </div>
      </FormStep>
    </div>
  );
};

export default CreditScore;
